import Axios from "axios";

const apiBaseUrl =
  "https://4dnynix9v3.execute-api.eu-west-2.amazonaws.com/Dev/app";

export const fetchPostDetails = {
  key: "fetchPostDetails",
  fetcher: async (postId: string, userId: string) => {
    const fetchPostDetailsResponse = await Axios.get(
      `${apiBaseUrl}/api/posts/${postId}?userId=${userId}`,
      {
        headers: { "x-api-key": "jz1QmIoxzF5UoX9rJ05kS7ACG3OMJO8J8PzhhzKu" }
      }
    );
    return fetchPostDetailsResponse.data;
  }
};

export const submitAnswer = async ({
  userId,
  postId,
  questionId,
  optionId,
  text
}: {
  userId: string;
  postId: string;
  questionId: string;
  optionId: string;
  text: string;
}) => {
  const submitAnswerResponse = await Axios.post(
    `${apiBaseUrl}/api/posts/${postId}/questions/${questionId}/answers?userId=${userId}`,
    { questionId, optionId, text },
    {
      headers: { "x-api-key": "jz1QmIoxzF5UoX9rJ05kS7ACG3OMJO8J8PzhhzKu" }
    }
  );
  return submitAnswerResponse.data;
};
